import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbActiveModal, NgbCalendar, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import * as _ from "lodash";
import * as moment from "moment";
import { SubmittedFormFilterService } from "./submitted-form-filter.service";
import { CapabilityEngineService } from "../capabilityEngine.service";

@Component({
    selector: "app-submitted-form-filter",
    templateUrl: "submitted-form-filter.component.html"
})
export class SubmittedFormListFilterComponent implements OnInit {
    @Input() parentComponentData;
    @Output() dateSelect = new EventEmitter<NgbDateStruct>();

    currentPage: String;
    dropdownSettings = {
        singleSelection: false,
        idField: "_id",
        textField: "name",
        selectAllText: "Select All",
        unSelectAllText: "UnSelect All",
        // itemsShowLimit: 3,
        enableCheckAll: true,
        allowSearchFilter: true
    };
    dateRange = {
        submitted: false,
        reviewed: false
    };

    statusDataList = [];
    // worksAreasDataList = [];
    inspectedUsersDataList = [];
    PresentDay: any;
    messageFrom: String;
    messageTo: String;
    messagereviewFrom: String;
    messagereviewTo: String;
    selecteditem: String [] = [];
    

    selectedSubmittedFrom = undefined;
    selectedSubmittedTo = undefined;
    selectedReviewedFrom = undefined;
    selectedReviewedTo = undefined;
    selectedTaskStatusList = [];
    // selectedWorkAreasList = [];
    selectedInspectedUsersList = [];
    selectedContainsHazardsStatus: Boolean;

    reviewOptionsData = [];
    selectedReviewFeedBack = [];

    constructor(
        private _submittedFormFilterService: SubmittedFormFilterService,
        private _router: Router,
        public activeModal: NgbActiveModal,
        private route: ActivatedRoute,
        private calender: NgbCalendar,
        private _capabilityEngineService: CapabilityEngineService,
    ) {
        this.currentPage = this.route.root.firstChild.snapshot.data[
            "currentPage"
        ];
        this.PresentDay = this.getFormattedDate(new Date());
    }

    ngOnInit() {
        this._submittedFormFilterService
            .getInitialDataForSubmittedFilter()
            .subscribe((result: any) => {
                // console.log(result);
                // filter code starts
                // this.worksAreasDataList = result.data.workAreasList;
                this.inspectedUsersDataList = result.data.usersList;
                
                if(this.parentComponentData.reviewOptions) {
                    this.reviewOptionsData = this.parentComponentData.reviewOptions;
                }
                this.inspectedUsersDataList = _.filter(this.inspectedUsersDataList, (user) => {
                    return user['status'] != 0
                })
                this.statusDataList = [
                    { _id: "submitted", name: "Submitted" },
                    { _id: "reviewed", name: "Reviewed" }
                ];
                this.selectedTaskStatusList = [];
                let parentQueryParams = this.parentComponentData.queryParams;
                // Added this for Auto fetching applied list types on opening the popup
                var items = []
                _.forEach(parentQueryParams.status, function(status){
                    items.push(status.name);
                });
                this.selecteditem = items;
                // end of auto fetching code for selected list

                // tslint:disable-next-line:max-line-length
                this.selectedSubmittedFrom = parentQueryParams.submittedFrom
                    ? this.getFormattedDate(parentQueryParams.submittedFrom)
                    : undefined;
                this.selectedSubmittedTo = parentQueryParams.submittedTo
                    ? this.getFormattedDate(parentQueryParams.submittedTo)
                    : undefined;
                // tslint:disable-next-line:max-line-length
                this.selectedReviewedFrom = parentQueryParams.reviewedFrom
                    ? this.getFormattedDate(parentQueryParams.reviewedFrom)
                    : undefined;
                this.selectedReviewedTo = parentQueryParams.reviewedTo
                    ? this.getFormattedDate(parentQueryParams.reviewedTo)
                    : undefined;
                this.selectedTaskStatusList = parentQueryParams.status
                    ? parentQueryParams.status
                    : [];
                // this.selectedWorkAreasList = parentQueryParams.wid
                //     ? parentQueryParams.wid
                //     : [];
                this.selectedInspectedUsersList = parentQueryParams.uid
                    ? parentQueryParams.uid
                    : [];
                if(parentQueryParams.reviewFeedBack) {
                    this.selectedReviewFeedBack = parentQueryParams.reviewFeedBack
                }
                if (parentQueryParams.containsHazards) {
                    if (parentQueryParams.containsHazards === "true") {
                        this.selectedContainsHazardsStatus = true;
                    } else if (parentQueryParams.containsHazards === "false") {
                        this.selectedContainsHazardsStatus = false;
                    }
                }
                _.forEach(this.selectedTaskStatusList, item => {
                    this.setDateRangeVisibility(item);
                });
            });
    }

    getFormattedDate(date) {
        return {
            year: moment(date).year(),
            month: moment(date).month() + 1, // This is because in moment() months numbered from 0 to 11.
            day: moment(date).date()
        };
    }

    // onItemSelect(item: any) {
    //     console.log(item);
    // }

    // onSelectAll(items: any) {
    //     console.log(items);
    // }

    onItemSelect(item: any) {
        this.setDateRangeVisibility(item);
        this.selecteditem.push(item.name)
    }

    setDateRangeVisibility(item: any) {
        if (item._id === "submitted") {
            this.dateRange.submitted = true;
        } else if (item._id === "reviewed") {
            this.dateRange.reviewed = true;
        }
    }

    onItemDeSelect(item: any) {
        if (item._id === "submitted") {
            this.dateRange.submitted = false;
            this.selectedSubmittedFrom = undefined;
            this.selectedSubmittedTo = undefined;
        } else if (item._id === "reviewed") {
            this.dateRange.reviewed = false;
            this.selectedReviewedFrom = undefined;
            this.selectedReviewedTo = undefined;
        }
    }

    close() {
        this.clearFilters();
        this.activeModal.dismiss();
    }

    clearFilters() {
        this.selectedTaskStatusList = [];
        // this.selectedWorkAreasList = [];
        this.selectedInspectedUsersList = [];
        this.selectedContainsHazardsStatus = undefined;
        this.selectedSubmittedFrom = undefined;
        this.selectedSubmittedTo = undefined;
        this.selectedReviewedFrom = undefined;
        this.selectedReviewedTo = undefined;
        this.dateRange = {
            submitted: false,
            reviewed: false
        };
        this.messageFrom = "";
        this.messageTo = "";
        this.messagereviewFrom = "";
        this.messagereviewTo = "";
        this.selectedReviewFeedBack = [];
    }

    getFilteredData() {
        let isFilters = "false";
        // tslint:disable-next-line:max-line-length _.isEmpty(this.selectedWorkAreasList) &&
        if (
            _.isEmpty(this.selectedTaskStatusList) &&
            _.isEmpty(this.selectedInspectedUsersList) &&
            this.selectedContainsHazardsStatus === undefined &&
            !this.selectedSubmittedFrom &&
            !this.selectedSubmittedTo &&
            !this.selectedReviewedFrom &&
            !this.selectedReviewedTo && 
            !this.selectedReviewFeedBack
        ) {
            isFilters = "false";
        } else {
            isFilters = "true";
        }
        console.log(this.selecteditem);
        if (this.selecteditem.indexOf('Submitted') > -1) {
            // console.log("submitted", this.selectedSubmittedFrom, this.selectedSubmittedTo);
            this.messageFrom = "";
            this.messageTo = "";
            if((this.selectedSubmittedFrom && !this.selectedSubmittedTo) || (!this.selectedSubmittedFrom && this.selectedSubmittedTo))
                {
                if (!this.selectedSubmittedFrom) {
                    this.messageFrom = "Select Date";
                    return;
                }
                if (!this.selectedSubmittedTo) {
                    this.messageTo = "Select Date";
                    return;
                }
            }
        }

        if (this.selecteditem.indexOf('Reviewed') > -1) {
            // console.log("Reviewed", this.selectedReviewedFrom, this.selectedReviewedTo)

            if ((this.selectedReviewedFrom && !this.selectedReviewedTo) ||  (!this.selectedReviewedFrom && this.selectedReviewedTo))
            {
                this.messagereviewFrom = "";
                this.messagereviewTo = "";
                // console.log(this.selectedReviewedFrom, this.selectedReviewedTo);
                if (!this.selectedReviewedFrom) {
                    this.messagereviewFrom = "Select Date";
                    return;
                }
                if (!this.selectedReviewedTo) {
                    this.messagereviewTo = "Select Date";
                    return;
                }
            }
        }


        console.log(
            "TCL: SubmittedFormListFilterComponent -> getFilteredData -> isFilters",
            isFilters
        );

        let redirectUrl;
            if(this.parentComponentData.queryParams.key && this.parentComponentData.queryParams.formName){
                redirectUrl = '/submittedFormList/' + this.parentComponentData.templateId + '?formName=' + this.parentComponentData.queryParams.formName + '&key=' + this.parentComponentData.queryParams.key + '&display=' + this.parentComponentData.queryParams.display + "&filter=" +isFilters;
            }else{
                redirectUrl = "/submittedFormList/" + this.parentComponentData.templateId +"?filter=" +isFilters;
            }
        _.forEach(this.selectedTaskStatusList, status => {
            redirectUrl = redirectUrl.concat("&status=" + status._id);
        });
        // _.forEach(this.selectedWorkAreasList, workArea => {
        //     redirectUrl = redirectUrl.concat("&wid=" + workArea._id);
        //     redirectUrl = redirectUrl.concat(
        //         "&" + workArea._id + "=" + encodeURI(workArea.name)
        //     );
        // });
        _.forEach(this.selectedInspectedUsersList, user => {
            redirectUrl = redirectUrl.concat("&uid=" + user._id);
            redirectUrl = redirectUrl.concat(
                "&" + user._id + "=" + encodeURI(user.name)
            );
        });
        if (this.selectedContainsHazardsStatus !== undefined) {
            redirectUrl = redirectUrl.concat(
                "&containsHazards=" + this.selectedContainsHazardsStatus
            );
        }
        if (this.selectedSubmittedFrom && this.selectedSubmittedTo) {
            redirectUrl = redirectUrl.concat(
                "&submittedFrom=" +
                    this.getFormatedDate(this.selectedSubmittedFrom, "START")
            );
            redirectUrl = redirectUrl.concat(
                "&submittedTo=" +
                    this.getFormatedDate(this.selectedSubmittedTo, "END")
            );
        }
        if (this.selectedReviewedFrom && this.selectedReviewedTo) {
            redirectUrl = redirectUrl.concat(
                "&reviewedFrom=" +
                    this.getFormatedDate(this.selectedReviewedFrom, "START")
            );
            redirectUrl = redirectUrl.concat(
                "&reviewedTo=" +
                    this.getFormatedDate(this.selectedReviewedTo, "END")
            );
        }
        if(this.selectedReviewFeedBack && this.selectedReviewFeedBack.length > 0){
            _.forEach(this.selectedReviewFeedBack, reviewFeedBack => {
                redirectUrl = redirectUrl.concat("&reviewFeedBack=" + reviewFeedBack._id);
            });
        }

        this._router.navigateByUrl(redirectUrl);
        this.close();
    }

    resetError(type) {
        console.log(type);
        switch (type) {
            case "reviewedFrom":
                this.messagereviewFrom = "";
                break;
            case "reviewedTo":
                this.messagereviewTo = "";
                break;
            case "submittedFrom":
                this.messageFrom = "";
                break;
            case "submittedTo":
                this.messageTo = "";
                break;
        }
    }

    getFormatedDate(date: any, type) {
        date.month = date.month - 1; // This is because in moment() months numbered from 0 to 11.
        if (type === "START") {
            return moment(date)
                .utc()
                .format();
        }
        if (type === "END") {
            return moment(date)
                .endOf("d")
                .utc()
                .format();
        }
    }

    clearDateData(abc) {
        this[abc] = undefined;
    }

    isFormhound(){
        return this._capabilityEngineService.isFormhound();
    }

    isOshaMshaForm(){
        return this._capabilityEngineService.isOshaMshaForm();
    }

}



// WEBPACK FOOTER //
// ./src/app/submitted-form-filter/submitted-form-filter.component.ts